import {getMethod} from '@/api'

async function get(params) {
    return await getMethod('/api/itinerary', params, null, {responseType: 'arraybuffer'})
}

export {get}
